export default __webpack_public_path__ + "static/media/moodThree.b4a9130d.png";